import React, { useState } from 'react';

const ProfileEdit: React.FC = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');

  const handleSave = () => {
    // 여기서 API 호출 등을 통해 사용자 정보를 저장
    console.log('저장된 정보:', { name, email, phone });
  };

  return (
    <div className="profile-edit">
      <h1>개인정보 수정</h1>
      <div>
        <label>이름</label>
        <input
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="이름을 입력하세요"
        />
      </div>
      <div>
        <label>이메일</label>
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="이메일을 입력하세요"
        />
      </div>
      <div>
        <label>전화번호</label>
        <input
          type="tel"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
          placeholder="전화번호를 입력하세요"
        />
      </div>
      <button onClick={handleSave}>저장</button>
    </div>
  );
};

export default ProfileEdit;
